<template>
    <div v-if="spaceFetched">
        <BreadCrumb></BreadCrumb>
        <h2>Space-Vorlage bearbeiten</h2>
        <transition name="fade" mode="out-in">
            <div v-if="loading" :key="0" class="loader">
                <dot-loader id="loader"></dot-loader>
            </div>
            <div :key="1">
                <div class="input-row">
                    <inputFloatLabel style="width: 48%" label="Vorlagenname" @input="moduleNameChanged"
                                     :value="space.name"></inputFloatLabel>
                    <inputFloatLabel style="width: 48%" label="Technischer Name" @input="technicalNameChanged"
                                     :value="space.technical_name"></inputFloatLabel>
                </div>
                <div class="item-row">
                    <div class="add-buttons">
                        <AdaButton style="margin-right: 10px" :custom-styles="addModuleStyles"
                                   title="MODUL-VORLAGE LADEN"
                                   @click="openAddModulesDialog" type="createButton" icon="icon-load"></AdaButton>
                        <AdaButton title="INTERACTION HINZUFÜGEN" @click="openAddInteractionsDialog" type="createButton"
                                   icon="icon-add"></AdaButton>
                    </div>
                </div>
                <div>
                    <AdaDatatable :columns="columns" :data="[]" :show-pagination="false" :show-search="false"
                                  :size-of-page="0">
                    </AdaDatatable>
                    <InteractionRow v-for="(inter, index) in interactions" v-bind:key="inter.id" :name="inter.name"
                                    :technical-name="space.technical_name + inter.technical_name" :actions="['delete']"
                                    @onDelete="removeInteraction(inter)"
                                    @moveUp="moveInteractionUp(index)"
                                    @moveDown="moveInteractionDown(index)"
                                    :description="inter.description" :widths="columns" :hide-move="false">
                    </InteractionRow>
                    <div class="module-container" v-for="(module,index) in modules"
                         v-bind:key="module.id + module.technical_name">
                        <SpaceGroupRow style="margin-top: 5px" :text="module.name"
                                       :hide-toggle-icon="true"
                                       @toggleVisibility="module.hide = !module.hide"
                                       @moveUp="moveUp(index)"
                                       @moveDown="moveDown(index)"
                                       @onDelete="deleteModule(module)"
                                       @onDuplicate="duplicateModule(module)">
                        </SpaceGroupRow>
                        <InteractionRow v-for="inter in module.interactions" v-bind:key="module.id + '' + inter.id"
                                        :name="inter.name"
                                        :technical-name="space.technical_name + '_' + module.technical_name + inter.technical_name"
                                        :description="inter.description" :widths="columns">
                        </InteractionRow>
                    </div>
                </div>
                <AdaButton icon="icon-add" @click="openAddInteractionsDialog" type="fullWidthButton"
                           title="INTERACTION HINZUFÜGEN"></AdaButton>
                <div style="margin-top: 20px">
                    <AdaButton :loading="savingTemplate" style="width: 300px; height: 40px" title="SPACE SPEICHERN"
                               @click="saveClicked"
                               type="createButton"></AdaButton>
                </div>
            </div>
        </transition>
        <Dialog v-if="showAddInteractionsDialog" :show-close-button="true" :show="showAddInteractionsDialog"
                :has-backdrop="true" width="80%" max-width="1200px"
                @close="closeAddInteractionsDialog">
            <SelectInteractionsFromTable :initial-interactions="interactions"
                                         @selected="interactionsSelected"></SelectInteractionsFromTable>
        </Dialog>
        <Dialog v-if="showAddModulesDialog" :show-close-button="true" :show="showAddModulesDialog"
                :has-backdrop="true" width="80%" max-width="1200px"
                @close="closeAddModulesDialog">
            <SelectModulesFromTable :initial-modules="modules"
                                    @selected="modulesSelected"></SelectModulesFromTable>
        </Dialog>
    </div>
</template>

<script>

import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import AdaDatatable from "../../../components/tables/AdaDatatable";
import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
import {RepositoryFactory} from "../../../scripts/RepositoryFactory";
import AdaButton from "../../../components/buttons/AdaButton";
import Dialog from "../../../components/dialog/Dialog";
import SelectInteractionsFromTable from "../modules/SelectInteractionsFromTable";
import SelectModulesFromTable from "./SelectModulesFromTable";
import SpaceGroupRow from "./SpaceGroupRow";
import InteractionRow from "./InteractionRow";

const SpacesRepository = RepositoryFactory.get('spaces');

export default {
    components: {
        InteractionRow,
        SelectModulesFromTable,
        BreadCrumb,
        AdaDatatable,
        InputFloatLabel,
        SelectInteractionsFromTable,
        AdaButton,
        Dialog,
        SpaceGroupRow
    },
    data: function () {
        return {
            addModuleStyles: {
                'background-color': '#00b6ed',
                'border-color': '#00b6ed'
            },
            addInteractionStyles: {
                'background-color': '#f6f7f8',
                'border-color': '#f6f7f8',
                'color': '#d70364'
            },
            modules: [],
            interactions: [],
            space: [],
            showAddInteractionsDialog: false,
            showAddModulesDialog: false,
            spaceName: '',
            technicalName: '',
            spaceFetched: 'false',
            columns: [
                {
                    viewName: 'Name',
                    propName: 'name',
                    width: '25%'
                },
                {
                    viewName: 'Technischer Name',
                    propName: 'technical_name',
                    width: '25%'
                },
                {
                    viewName: 'Aktion',
                    propName: 'action',
                    width: '10%'
                },
                {
                    viewName: 'Beschreibung',
                    propName: 'description',
                    width: '40%'
                }
            ],
            transformers: [
                {
                    propName: 'action',
                    transform: function (value) {
                        let res = '';
                        value.forEach(action => {
                            switch (action) {
                                case 'edit':
                                    res += '<span data-type="edit" class="margin-right hover-highlight icon-edit"></span>';
                                    break;
                                case 'copy':
                                    res += '<span data-type="duplicate" class="margin-right hover-highlight icon-duplicate"></span>';
                                    break;
                                case 'delete':
                                    res += '<span data-type="delete" class="margin-right hover-highlight icon-delete"></span>';
                                    break;
                            }
                        });
                        return res;
                    }
                }
            ],
            savingTemplate: false,
            loading: true,
            fn: null
        }
    },
    name: "EditSpaceTemplate",
    mounted() {
        this.fetchSpace();
        this.fn = () => {
            this.saveClicked(true);
        };
        this.$root.$on('saveSpaceTemplate', this.fn);
    },
    beforeDestroy() {
        this.$root.$off('saveSpaceTemplate', this.fn);
    },
    methods: {
        arrayMove(array, from, to) {
            array.splice(to, 0, array.splice(from, 1)[0]);
        },
        moveUp(index) {
            if (index > 0) {
                this.arrayMove(this.modules, index, index - 1);
            }
        },
        moveDown(index) {
            if (index < this.modules.length - 1) {
                this.arrayMove(this.modules, index, index + 1);
            }
        },
        moveInteractionUp(index) {
            if (index > 0) {
                this.arrayMove(this.interactions, index, index - 1);
            }
        },
        moveInteractionDown(index) {
            if (index < this.interactions.length - 1) {
                this.arrayMove(this.interactions, index, index + 1);
            }
        },
        async fetchSpace() {
            this.loading = true;
            try {
                const {data} = await SpacesRepository.getSpace(this.$route.params.id);
                this.space = data;
                this.spaceFetched = true;
                this.interactions = this.space.interactions;
                this.interactions.forEach(inter => {
                    inter.action = ['copy', 'edit', 'delete'];
                    inter.selected = true;
                });
                this.interactions = this.interactions.sort(this.sortByPivot);
                this.space.modules = this.space.modules.sort(this.sortByPivot);
                this.modules = this.space.modules;
                this.modules.forEach((mod, index) => {
                    mod.hide = index !== 0;
                    mod.interactions = mod.interactions.sort(this.sortByPivot);
                    if (mod.pivot.count > 1) {
                        for (let i = 0; i < mod.pivot.count - 1; i++) {
                            this.duplicateModule(mod);
                        }
                    }
                })
            } catch (e) {
                console.error(e);
                this.$noty.error('Space konnte nicht geladen werden.');
            }
            this.loading = false;
        },
        sortByPivot(a, b) {
            if (a.pivot.sort < b.pivot.sort) {
                return -1;
            }
            if (a.pivot.sort > b.pivot.sort) {
                return 1;
            }
            return 0;
        },
        saveClicked(clickedFromHeader = false) {
            clickedFromHeader ? this.$root.$emit('trackinglistLoader', true) : this.savingTemplate = true;
            this.editSpace(clickedFromHeader);
        },
        async editSpace(clickedFromHeader) {
            try {
                const json = {
                    id: this.space.id,
                    name: this.space.name,
                    technical_name: this.space.technical_name,
                    interactionIds: this.interactions.map(inter => inter.id),
                    moduleIds: this.modules.map(mod => mod.id)
                };
                await SpacesRepository.updateSpace(this.space.id, json);
                this.$noty.success("Die Spacevorlage wurde erfolgreich gespeichert!");
                this.$router.push({name: 'templatespaces'});
            } catch (e) {
                console.error(e);
                this.$noty.error("Fehler bei der Aktualisierung der Spacevorlage: " + e.message);
            }
            clickedFromHeader ? this.$root.$emit('trackinglistLoader', false) : this.savingTemplate = false;
        },
        interactionsSelected(selectedInteractions) {
            selectedInteractions.forEach(inter => {
                inter.action = ['copy', 'edit', 'delete'];
            });
            this.interactions = selectedInteractions;
            this.showAddInteractionsDialog = false;
        },
        modulesSelected(selectedModules) {
            selectedModules.forEach(module => {
                module.action = ['copy', 'edit', 'delete'];
            });
            this.modules = selectedModules;
            this.showAddModulesDialog = false;
        },
        cellClicked: function (data) {
            let dataType = data.target.getAttribute('data-type');
            switch (dataType) {
                case 'edit':
                    this.$router.push({name: 'editModule', params: {id: data.row.id}});
                    break;
                case 'duplicate':
                    this.copyClicked(data.row);
                    break;
                case 'delete':
                    this.showDeleteCampaignDialog = true;
                    this.deleteCampaign = data.row;
                    break;
            }
        },
        moduleNameChanged(val) {
            this.space.name = val;
        },
        technicalNameChanged(val) {
            this.space.technical_name = val;
        },
        openAddInteractionsDialog() {
            this.showAddInteractionsDialog = true;
        },
        closeAddInteractionsDialog() {
            this.showAddInteractionsDialog = false;
        },
        openAddModulesDialog() {
            this.showAddModulesDialog = true;
        },
        closeAddModulesDialog() {
            this.showAddModulesDialog = false;
        },
        removeInteraction(inter) {
            this.interactions.splice(this.interactions.indexOf(inter), 1);
        },
        deleteModule(module) {
            this.modules.splice(this.modules.indexOf(module), 1);
        },
        duplicateModule(module) {
            let nrOfModules = this.getNumberOfModulesById(module.id);
            let newModule = JSON.parse(JSON.stringify(module));
            newModule.name = newModule.name + (nrOfModules + 1);
            newModule.technical_name = newModule.technical_name + (nrOfModules + 1);
            this.modules.push(newModule);
        },
        getNumberOfModulesById(id) {
            let count = 0;
            this.modules.forEach(module => {
                if (module.id === id) {
                    count += 1;
                }
            });
            return count;
        }
    }
}
</script>

<style lang="scss" scoped>

.input-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 10px;
}

.item-row {
    display: flex;
    flex-direction: row;
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: white;
    padding: 10px;
    justify-content: space-between;
}

.add-buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-left: auto;
}

.module-container {
    border-bottom: solid 1px $grey;
    border-top: solid 1px $grey;
}

.loader {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    width: 100%;
}

::v-deep .ada-table-container tr {
    display: flex;
}

::v-deep .ada-table-container td {
    display: block;
}

</style>